var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntlogyWsGridIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5ca313d0c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 201.605469 202.394531 L 570.535156 202.394531 L 570.535156 353.265625 L 201.605469 353.265625 Z M 201.605469 202.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "86cfd6f411"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 224.105469 202.394531 L 547.722656 202.394531 C 553.691406 202.394531 559.414062 204.765625 563.632812 208.984375 C 567.851562 213.203125 570.222656 218.925781 570.222656 224.894531 L 570.222656 330.765625 C 570.222656 336.734375 567.851562 342.457031 563.632812 346.675781 C 559.414062 350.894531 553.691406 353.265625 547.722656 353.265625 L 224.105469 353.265625 C 218.136719 353.265625 212.414062 350.894531 208.195312 346.675781 C 203.976562 342.457031 201.605469 336.734375 201.605469 330.765625 L 201.605469 224.894531 C 201.605469 218.925781 203.976562 213.203125 208.195312 208.984375 C 212.414062 204.765625 218.136719 202.394531 224.105469 202.394531 Z M 224.105469 202.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "842bb0a25f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.605469 0.394531 L 369 0.394531 L 369 151.265625 L 0.605469 151.265625 Z M 0.605469 0.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "761277da94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.105469 0.394531 L 346.722656 0.394531 C 352.691406 0.394531 358.414062 2.765625 362.632812 6.984375 C 366.851562 11.203125 369.222656 16.925781 369.222656 22.894531 L 369.222656 128.765625 C 369.222656 134.734375 366.851562 140.457031 362.632812 144.675781 C 358.414062 148.894531 352.691406 151.265625 346.722656 151.265625 L 23.105469 151.265625 C 17.136719 151.265625 11.414062 148.894531 7.195312 144.675781 C 2.976562 140.457031 0.605469 134.734375 0.605469 128.765625 L 0.605469 22.894531 C 0.605469 16.925781 2.976562 11.203125 7.195312 6.984375 C 11.414062 2.765625 17.136719 0.394531 23.105469 0.394531 Z M 23.105469 0.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd413e21e9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 370,
    y: 0,
    height: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a97bbc9c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 21.734375 L 171.914062 21.734375 L 171.914062 353.757812 L 29.777344 353.757812 Z M 29.777344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c47cd0370d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 21.734375 L 149.414062 21.734375 C 155.382812 21.734375 161.105469 24.105469 165.324219 28.324219 C 169.542969 32.542969 171.914062 38.265625 171.914062 44.234375 L 171.914062 330.765625 C 171.914062 336.734375 169.542969 342.457031 165.324219 346.675781 C 161.105469 350.894531 155.382812 353.265625 149.414062 353.265625 L 52.277344 353.265625 C 46.308594 353.265625 40.585938 350.894531 36.367188 346.675781 C 32.148438 342.457031 29.777344 336.734375 29.777344 330.765625 L 29.777344 44.234375 C 29.777344 38.265625 32.148438 32.542969 36.367188 28.324219 C 40.585938 24.105469 46.308594 21.734375 52.277344 21.734375 Z M 52.277344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba3548a16d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.734375 L 142.914062 0.734375 L 142.914062 332.28125 L 0.777344 332.28125 Z M 0.777344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b165db71e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.734375 L 120.414062 0.734375 C 126.382812 0.734375 132.105469 3.105469 136.324219 7.324219 C 140.542969 11.542969 142.914062 17.265625 142.914062 23.234375 L 142.914062 309.765625 C 142.914062 315.734375 140.542969 321.457031 136.324219 325.675781 C 132.105469 329.894531 126.382812 332.265625 120.414062 332.265625 L 23.277344 332.265625 C 17.308594 332.265625 11.585938 329.894531 7.367188 325.675781 C 3.148438 321.457031 0.777344 315.734375 0.777344 309.765625 L 0.777344 23.234375 C 0.777344 17.265625 3.148438 11.542969 7.367188 7.324219 C 11.585938 3.105469 17.308594 0.734375 23.277344 0.734375 Z M 23.277344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68aff00afb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 143,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c618b60c1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 201.914062 21.734375 L 570.84375 21.734375 L 570.84375 172.605469 L 201.914062 172.605469 Z M 201.914062 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f00d82cae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 224.414062 21.734375 L 548.03125 21.734375 C 554 21.734375 559.722656 24.105469 563.941406 28.324219 C 568.160156 32.542969 570.53125 38.265625 570.53125 44.234375 L 570.53125 150.105469 C 570.53125 156.074219 568.160156 161.796875 563.941406 166.015625 C 559.722656 170.234375 554 172.605469 548.03125 172.605469 L 224.414062 172.605469 C 218.445312 172.605469 212.722656 170.234375 208.503906 166.015625 C 204.285156 161.796875 201.914062 156.074219 201.914062 150.105469 L 201.914062 44.234375 C 201.914062 38.265625 204.285156 32.542969 208.503906 28.324219 C 212.722656 24.105469 218.445312 21.734375 224.414062 21.734375 Z M 224.414062 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "59cda7beae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.914062 0.734375 L 369.71875 0.734375 L 369.71875 151.605469 L 0.914062 151.605469 Z M 0.914062 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4fe0c018b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.414062 0.734375 L 347.03125 0.734375 C 353 0.734375 358.722656 3.105469 362.941406 7.324219 C 367.160156 11.542969 369.53125 17.265625 369.53125 23.234375 L 369.53125 129.105469 C 369.53125 135.074219 367.160156 140.796875 362.941406 145.015625 C 358.722656 149.234375 353 151.605469 347.03125 151.605469 L 23.414062 151.605469 C 17.445312 151.605469 11.722656 149.234375 7.503906 145.015625 C 3.285156 140.796875 0.914062 135.074219 0.914062 129.105469 L 0.914062 23.234375 C 0.914062 17.265625 3.285156 11.542969 7.503906 7.324219 C 11.722656 3.105469 17.445312 0.734375 23.414062 0.734375 Z M 23.414062 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2de95bdbb2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 370,
    y: 0,
    height: 152
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5ca313d0c0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#86cfd6f411)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 201, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fd413e21e9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#842bb0a25f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#761277da94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.605469 0.394531 L 368.949219 0.394531 L 368.949219 151.265625 L 0.605469 151.265625 Z M 0.605469 0.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a97bbc9c7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c47cd0370d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68aff00afb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba3548a16d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b165db71e9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.734375 L 142.914062 0.734375 L 142.914062 332.199219 L 0.777344 332.199219 Z M 0.777344 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c618b60c1c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f00d82cae)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 201, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2de95bdbb2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59cda7beae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4fe0c018b5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.914062 0.734375 L 369.257812 0.734375 L 369.257812 151.605469 L 0.914062 151.605469 Z M 0.914062 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntlogyWsGridIcon1);
export default __webpack_public_path__ + "static/media/antlogyWSGridIcon1.7ea3738cb6112a64bfd6460c9b3c8e9d.svg";
export { ForwardRef as ReactComponent };